import React, { useEffect, useState, useReducer, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { ModalContext } from 'modaaals'
import { formatDistanceToNow } from 'date-fns'
import useSocket from 'use-socket.io-client'
import useSWR from 'swr'
import { authRequest } from './api'

import TextWithTemplate from './TextWithTemplate'

import {
  sortByDate_DESC as sortByDate,
  sortByTime_DESC as sortByTime,
  RequestItem,
} from './Home'
import { hasNewMessages } from './RequestDetail'
import SecureButton from './SecureButton'

import styles from './request.module.css'

export default function UserDetail() {
  let { userId } = useParams()
  const { data: info, mutate } = useSWR(`/admin/user?id=${userId}`, authRequest)

  const { openModal } = useContext(ModalContext)

  const [emailStatus, dispatch] = useReducer(reducer, initialState)
  const [emailContent, setEmailContent] = useState('')

  const [socket] = useSocket(`/`, {
    autoConnect: false,
  })

  useEffect(() => {
    socket.connect()
    socket.on('connect', function () {
      socket.emit('room', userId)
    })
    socket.on('chat-msg-from-client', mutate)
    socket.on('message-read', mutate)
    socket.on('new-entry', mutate)
    return () => socket.disconnect()
  }, [socket, userId, mutate])

  function sendEmai() {
    if (emailContent !== '') {
      dispatch('loading')
      authRequest(`/admin/email`, {
        method: 'POST',
        body: JSON.stringify({
          id: userId,
          name: info.name,
          message: emailContent,
        }),
      })
        .then(({ user }) => {
          mutate(user, false)
          dispatch('sent')
          setEmailContent('')
        })
        .catch((err) => {
          console.log({ err })
          dispatch('error')
        })
    }
  }

  const newMessages = info
    ? hasNewMessages(info.messagesOpenedOn, info.messages)
    : null

  return info && Object.keys(info).length > 0 ? (
    <section className="wrapper json-form detail-grid">
      <div>
        {info.name && (
          <h3>
            {info.name}'s Requests
            <button
              className="btn btn-info btn-sm"
              style={{ marginLeft: '1em', position: 'relative' }}
              type="button"
              onClick={(e) => {
                e.preventDefault()
                openModal({ type: 'chat', userId })
              }}
            >
              Conversation
              {newMessages > 0 && (
                <span className={styles.badge}>{newMessages}</span>
              )}
            </button>
          </h3>
        )}
        <div>
          <h1 className="home-title">Quote</h1>
          {info.quote && info.quote.length > 0 ? (
            <ul className="list">
              {info.quote.sort(sortByDate).map((quote) => {
                return (
                  <RequestItem
                    {...quote}
                    userId={userId}
                    requestType="quote"
                    key={quote.id}
                  />
                )
              })}
            </ul>
          ) : (
            <div className="list">No Quotes yet</div>
          )}
        </div>
        <div>
          <h1 className="home-title">Supervision</h1>
          {info.supervision && info.supervision.length > 0 ? (
            <ul className="list">
              {info.supervision.sort(sortByDate).map((sup) => (
                <RequestItem
                  {...sup}
                  userId={userId}
                  requestType="supervision"
                  key={sup.id}
                />
              ))}
            </ul>
          ) : (
            <div className="list">No Quotes yet</div>
          )}
        </div>

        <div>
          <h1 className="home-title">Purchased</h1>
          {info.purchased && info.purchased.length > 0 ? (
            <ul className="list">
              {info.purchased.sort(sortByDate).map((pch) => (
                <RequestItem
                  {...pch}
                  userId={userId}
                  requestType="purchased"
                  key={pch.id}
                />
              ))}
            </ul>
          ) : (
            <div className="list">No Quotes yet</div>
          )}
        </div>

        <div>
          <h1 className="home-title">Messages sent</h1>
          {info.emailsSent && info.emailsSent.length > 0 ? (
            <ul className="list">
              {info.emailsSent.sort(sortByTime).map((info) => {
                return (
                  <div className="message-sent list-item" key={info.id}>
                    {info.message}
                    <small>
                      Sent{' '}
                      {formatDistanceToNow(new Date(info.time), {
                        includeSeconds: true,
                        addSuffix: true,
                      })}
                    </small>
                  </div>
                )
              })}
            </ul>
          ) : (
            <div className="list">Your sent messages history</div>
          )}
        </div>
      </div>
      <form
        className="send-email"
        onSubmit={(e) => {
          e.preventDefault()
          sendEmai()
        }}
      >
        <h3>Send Message{info.name ? ` to ${info.name}` : ''}</h3>

        <TextWithTemplate
          setTextContent={setEmailContent}
          textContent={emailContent}
          placeholder="Email message…"
          rows="5"
          kind="message"
          className="form-control"
          style={{ marginBottom: '.5em', resize: 'none' }}
          selectProps={{
            className: 'form-control',
          }}
          textareaLabel={<span style={{ marginBottom: '.5em' }}>Message</span>}
          selectLabel={<span style={{ marginBottom: '.5em' }}>Templates</span>}
        />

        <SecureButton
          confirm="Absolutely! Send that message…"
          confirmClassName="btn btn-danger"
          className="btn btn-info"
          type="submit"
          disabled={emailStatus.loading}
          onConfirm={() => {}}
        >
          Send Message
        </SecureButton>
        <br />
        <br />
        {emailStatus.sent && (
          <button
            onClick={() => dispatch('reset')}
            className="list-item inline"
            style={{ fontSize: '.7em' }}
          >
            Message Sent successfully
          </button>
        )}
        {emailStatus.error && (
          <button
            onClick={() => dispatch('reset')}
            className="list-item inline error"
            style={{ fontSize: '.7em' }}
          >
            Error sending email
          </button>
        )}
        {emailStatus.loading && (
          <span className="list-item inline" style={{ fontSize: '.7em' }}>
            Sending…
          </span>
        )}
      </form>
    </section>
  ) : null
}

const initialState = { sent: false, error: false, loading: false }
const reducer = (state, action) => {
  switch (action) {
    case 'sent':
      return {
        error: false,
        sent: true,
        loading: false,
      }
    case 'error':
      return {
        error: true,
        sent: false,
        loading: false,
      }
    case 'loading':
      return {
        ...state,
        loading: true,
      }
    case 'reset':
      return initialState
    default:
      throw new Error('Unexpected action')
  }
}
